module.exports = __webpack_public_path__ + "static/media/RetryTwoArrowsIcon.85cf4a4b.svg";